<template>
  <li class="contract-payment-methods__item" :class="{ 'contract-payment-methods__item--open': isOpen }">
    <button
      class="contract-payment-methods__trigger"
      type="button"
      :aria-expanded="isOpen"
      :aria-controls="bodyId"
      @click="toggle"
    >
      <span>{{ title }}</span>
      <img class="contract-payment-methods__arrow" src="@images/arrow-down.svg" v-svg-inline/>
    </button>

    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div v-if="isOpen" :id="bodyId" class="contract-payment-methods__body">
        <div class="contract-payment-methods__content">
          <slot/>
        </div>
      </div>
    </transition>
  </li>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue'

defineProps({
  title: { type: String, required: true },
})

const uid = getCurrentInstance()?.uid
const bodyId = computed(() => `contract-payment-method-${uid}`)
const isOpen = ref(false)

const toggle = () => {
  isOpen.value = !isOpen.value
}

const beforeEnter = (element) => {
  element.style.height = '0'
  element.style.opacity = '0'
}

const enter = (element) => {
  requestAnimationFrame(() => {
    element.style.height = `${element.scrollHeight}px`
    element.style.opacity = '1'
  })
}

const afterEnter = (element) => {
  element.style.height = 'auto'
}

const beforeLeave = (element) => {
  element.style.height = `${element.scrollHeight}px`
  element.style.opacity = '1'
}

const leave = (element) => {
  element.offsetHeight
  requestAnimationFrame(() => {
    element.style.height = '0'
    element.style.opacity = '0'
  })
}

const afterLeave = (element) => {
  element.style.height = ''
  element.style.opacity = ''
}
</script>
